import {
  createSlice,
  createAsyncThunk,
  createSelector,
  current,
} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getProspect = createAsyncThunk(
  "prospect/getProspect",
  async (
    {id, query, page, suburb, street_number_odd_even, streetId},
    {rejectWithValue}
  ) => {
    try {
      let res;

      if (query !== "") {
        res = await api.get(
          `${WiseBerryAPIEnv}prospect?suburb=${suburb}&direction=asc&limit=10&search_kw=${query}&sort_by=street_number&page=${page}&search_from_mobile=true&street_number_odd_even=${street_number_odd_even}`
        );
      } else {
        res = await api.get(
          `${WiseBerryAPIEnv}prospect?suburb=${suburb}&direction=asc&limit=10&street=${streetId}&sort_by=street_number&page=${page}&search_from_mobile=true&street_number_odd_even=${street_number_odd_even}`
        );
      }

      // if (type === "allocated_to") {
      //   res = await api.get(
      //     `${WiseBerryAPIEnv}prospect?allocated_to=${id}&direction=asc&limit=10&search_kw=${query}&sort_by=street_number&page=${page}`
      //   );
      // } else {
      //   res = await api.get(
      //     `${WiseBerryAPIEnv}prospect?zone=${zone}&direction=asc&limit=10&search_kw=${query}&sort_by=street_number&page=${page}`
      //   );
      // }

      return res.data;
    } catch (err) {
      // Error handling code
      return rejectWithValue(err);
    }
  }
);

export const getZone = createAsyncThunk(
  "prospect/getZone",
  async ({contacts, limit = 100, type = 1}, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}zone?contacts=${contacts}&limit=${limit}&type=${type}`
      );

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getProspectById = createAsyncThunk(
  "prospect/getProspectById",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}prospect/${id}`);

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getProspectNote = createAsyncThunk(
  "prospect/getProspectNote",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}prospect/notes?limit=1000&prospect=${id}`
      );

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const prospectCallReminder = createAsyncThunk(
  "prospect/prospectCallReminder",
  async (data, {rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}call-reminder`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success(res.data.message);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updateProspectById = createAsyncThunk(
  "prospect/updateProspectById",
  async (data, {rejectWithValue}) => {
    const { form, id, endpoint = '' } = data;

    try {
      // Construct the URL with optional endpoint suffix
      const url = `${WiseBerryAPIEnv}prospect/${id}${endpoint}`;

      console.log(`Making API request to: ${url}`);

      const response = await api.post(
        url,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const addProspect = createAsyncThunk(
  "prospect/addProspect",
  async (obj, {rejectWithValue}) => {
    // debugger;
    try {
      const response = await api.post(`${WiseBerryAPIEnv}prospect`, obj, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success(response.data.message);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addNote = createAsyncThunk(
  "prospect/addnote",
  async (data, {rejectWithValue}) => {
    const {form, type} = data;
    // debugger;
    try {
      let res;
      if (type == "general" || type === "prospectAddress") {
        res = await api.post(`${WiseBerryAPIEnv}note`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        res = await api.post(`${WiseBerryAPIEnv}history`, form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStreet = createAsyncThunk(
  "prospect/getStreet",
  async (street, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}street/organisation/search?search=${street}&limit=10`
      );

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addProspectContact = createAsyncThunk(
  "prospect/addProspectContact",
  async (obj, {rejectWithValue}) => {
    // debugger;
    try {
      const res = await api.post(`${WiseBerryAPIEnv}contact`, obj, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // toast.success(response.data.message);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getContact = createAsyncThunk(
  "prospect/getContact",
  async (search, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}contact?limit=10&search_kw=${search}`
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const addAppointment = createAsyncThunk(
  "prospect/addAppointment",
  async (obj, {rejectWithValue}) => {
    // debugger;
    try {
      const res = await api.post(`${WiseBerryAPIEnv}appointment`, obj, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // toast.success(response.data.message);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const PostEditContact = createAsyncThunk(
  "prospect/PostEditContact",
  async (data, {rejectWithValue}) => {
    const {form, id} = data;

    try {
      const res = await api.post(`${WiseBerryAPIEnv}contact/${id}`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // toast.success(response.data.message);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendPreListingMS = createAsyncThunk(
  "prospect/sendPreListingMS",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}appointment/send-pre-listing-email/${id}`
      );

      return res.data.data;
    } catch (err) {
      // Check if the error response exists, and return it
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data.data.message);
      }

      // If there's no response, just return the error object itself
      return rejectWithValue(err.message || "Unknown error occurred");
    }
  }
);

export const getOrganisationSuburbs = createAsyncThunk(
  "prospect/getOrganisationSuburbs",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}organisation/suburbs?limit=300`
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getOrganisationSuburbsStreet = createAsyncThunk(
  "prospect/getOrganisationSuburbsStreet",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}street?suburb=${id}&limit=1000`
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

let initialState = {
  prospects: [],
  loading: false,
  prospectsError: null,
  activeTab: "all",

  //getZone
  zones: [],
  loadingZone: false,
  zonesError: null,

  //   currentIndexSlice
  currentIndexSlice: 0,

  //   getProspectById
  individualProspect: [],
  individualProspectLoading: false,
  individualProspectError: null,

  // getProspectNote
  prospectNotes: [],
  prospectNotesLoading: false,
  prospectNotesError: null,

  // general Note
  showGeneralNotes: false,

  // updateProspectById

  updateStatus: null,
  updateLoading: false,
  updateError: null,

  // addNote

  notesUpdate: null,
  notesUpdateLoading: false,
  notesUpdateError: null,

  // callReminder
  callReminder: null,
  callReminderLoading: false,
  callReminderError: null,

  // getStreet
  searchedStreets: [],
  searchedStreetsLoading: false,
  searchedStreetsError: null,

  // addProspect
  newProspectAddress: null,
  newProspectLoading: false,
  newProspectError: null,

  // addProspectContact
  prospectContact: null,
  prospectContactLoading: false,
  prospectContactError: null,

  // getContact
  contacts: [],
  contactsLoading: false,
  contactsError: null,

  // addAppointment
  appointmentId: null,
  appointmentLoading: false,
  appointmentError: null,

  // SendPreListingMS
  preListingMs: null,
  preListingMsLoading: false,
  preListingMsError: null,

  // PostEditContact
  editedContact: null,
  editedContactLoading: false,
  editedContactError: null,

  // getOrganisationSuburbs
  organisationSuburbs: [],
  organisationSuburbsLoading: false,
  organisationSuburbsError: null,
  // getOrganisationSuburbsStreet
  organisationSuburbsStreet: [],
  organisationSuburbsLoadingStreet: false,
  organisationSuburbsErrorStreet: null,
};

const prospectSlice = createSlice({
  name: "prospectSlice",
  initialState,
  reducers: {
    clearProspects: (state) => {
      return initialState;
    },
    setActiveTab: (state, action) => {
      // Reducer to update the active tab
      state.activeTab = action.payload;
    },

    setGeneralNotes: (state, action) => {
      state.showGeneralNotes = action.payload;
    },
    setCurrentIndexSlice: (state, action) => {
      state.currentIndexSlice = action.payload;
    },
    incrementIndex: (state) => {
      state.currentIndexSlice += 1;
    },
    decrementIndex: (state) => {
      if (state.currentIndexSlice > 0) {
        state.currentIndexSlice -= 1;
      }
    },

    updateIndividualProspect: (state, action) => {
      const index = state.prospects?.data?.findIndex(
        (prospect) => prospect.id === action.payload.id
      );
      if (index !== -1) {
        let updated = state.prospects?.data[index];
        let newupdate = action.payload;
        // debugger;
        if (state.prospects.data) {
          state.prospects.data[index] = action.payload;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProspect.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProspect.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.prospects = action.payload;
        } else {
          const newData = [...state.prospects.data, ...action.payload.data];
          state.prospects.data = newData.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.id === item.id)
          );
          state.prospects.current_page = action.payload.current_page;
          state.prospects.first_page_url = action.payload.first_page_url;
          state.prospects.next_page_url = action.payload.next_page_url;
          state.prospects.prev_page_url = action.payload.prev_page_url;
          state.prospects.from = action.payload.from;
          state.prospects.to = action.payload.to;
        }

        state.loading = false;
        state.prospectsError = null;
      })
      .addCase(getProspect.rejected, (state, action) => {
        state.loading = false;
        state.prospectsError = action.payload;
        state.prospects = [];
      })

      .addCase(getZone.pending, (state) => {
        state.loadingZone = true;
      })

      .addCase(getZone.fulfilled, (state, action) => {
        state.loadingZone = false;
        state.zones = action.payload;
        state.zonesError = null;
      })
      .addCase(getZone.rejected, (state, action) => {
        state.loadingZone = false;
        state.zonesError = action.payload;
        state.zones = [];
      })
      .addCase(getProspectById.pending, (state) => {
        state.individualProspectLoading = true;
      })
      .addCase(getProspectById.fulfilled, (state, action) => {
        state.individualProspectLoading = false;
        state.individualProspect = action.payload;
        state.individualProspectError = null;
      })
      .addCase(getProspectById.rejected, (state, action) => {
        state.individualProspectLoading = false;
        state.individualProspectError = action.payload;
        state.individualProspect = [];
      })
      .addCase(getProspectNote.pending, (state) => {
        state.prospectNotesLoading = true;
      })
      .addCase(getProspectNote.fulfilled, (state, action) => {
        state.prospectNotesLoading = false;
        state.prospectNotes = action.payload;
        state.prospectNotesError = null;
      })
      .addCase(getProspectNote.rejected, (state, action) => {
        state.prospectNotesLoading = false;
        state.prospectNotesError = action.payload;
        state.prospectNotes = [];
      })
      .addCase(updateProspectById.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateProspectById.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateStatus = action.payload;
        state.updateError = null;
      })
      .addCase(updateProspectById.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
        state.updateStatus = null;
      })
      .addCase(addNote.pending, (state) => {
        state.notesUpdateLoading = true;
      })
      .addCase(addNote.fulfilled, (state, action) => {
        state.notesUpdateLoading = false;
        state.notesUpdate = action.payload;
        state.notesUpdateError = null;
      })
      .addCase(addNote.rejected, (state, action) => {
        state.notesUpdateLoading = false;
        state.notesUpdateError = action.payload;
        state.notesUpdate = null;
      })
      .addCase(prospectCallReminder.pending, (state) => {
        state.callReminderLoading = true;
      })
      .addCase(prospectCallReminder.fulfilled, (state, action) => {
        state.callReminderLoading = false;
        state.callReminder = action.payload;
        state.callReminderError = null;
      })
      .addCase(prospectCallReminder.rejected, (state, action) => {
        state.callReminderLoading = false;
        state.callReminderError = action.payload;
        state.callReminder = null;
      })
      .addCase(getStreet.pending, (state) => {
        state.searchedStreetsLoading = true;
      })
      .addCase(getStreet.fulfilled, (state, action) => {
        state.searchedStreetsLoading = false;
        state.searchedStreets = action.payload;
        state.searchedStreetsError = null;
      })
      .addCase(getStreet.rejected, (state, action) => {
        state.searchedStreetsLoading = false;
        state.searchedStreetsError = action.payload;
        state.searchedStreets = null;
      })
      .addCase(getOrganisationSuburbsStreet.pending, (state) => {
        state.organisationSuburbsLoadingStreet = true;
      })
      .addCase(getOrganisationSuburbsStreet.fulfilled, (state, action) => {
        state.organisationSuburbsLoadingStreet = false;
        state.organisationSuburbsStreet = action.payload;
        state.organisationSuburbsErrorStreet = null;
      })
      .addCase(getOrganisationSuburbsStreet.rejected, (state, action) => {
        state.organisationSuburbsLoadingStreet = false;
        state.organisationSuburbsErrorStreet = action.payload;
        state.organisationSuburbsStreet = null;
      })
      .addCase(addProspect.pending, (state) => {
        state.newProspectLoading = true;
      })
      .addCase(addProspect.fulfilled, (state, action) => {
        state.newProspectLoading = false;
        state.newProspectAddress = action.payload;
        state.newProspectError = null;
      })
      .addCase(addProspect.rejected, (state, action) => {
        state.newProspectLoading = false;
        state.newProspectError = action.payload;
        state.newProspectAddress = null;
      })
      .addCase(addProspectContact.pending, (state) => {
        state.prospectContactLoading = true;
      })
      .addCase(addProspectContact.fulfilled, (state, action) => {
        state.prospectContactLoading = false;
        state.prospectContact = action.payload;
        state.prospectContactError = null;
      })
      .addCase(addProspectContact.rejected, (state, action) => {
        state.prospectContactLoading = false;
        state.prospectContactError = action.payload;
        state.prospectContact = null;
      })
      .addCase(getContact.pending, (state) => {
        state.contactsLoading = true;
      })
      .addCase(getContact.fulfilled, (state, action) => {
        state.contactsLoading = false;
        state.contacts = action.payload;
        state.contactsError = null;
      })
      .addCase(getContact.rejected, (state, action) => {
        state.contactsLoading = false;
        state.contactsError = action.payload;
        state.contacts = [];
      })
      .addCase(addAppointment.pending, (state) => {
        state.appointmentLoading = true;
      })
      .addCase(addAppointment.fulfilled, (state, action) => {
        state.appointmentLoading = false;
        state.appointmentId = action.payload;
        state.appointmentError = null;
      })
      .addCase(addAppointment.rejected, (state, action) => {
        state.appointmentLoading = false;
        state.appointmentError = action.payload;
        state.appointmentId = null;
      })
      .addCase(sendPreListingMS.pending, (state) => {
        state.preListingMsLoading = true;
      })
      .addCase(sendPreListingMS.fulfilled, (state, action) => {
        state.preListingMsLoading = false;
        state.preListingMs = action.payload;
        state.preListingMsError = null;
      })
      .addCase(sendPreListingMS.rejected, (state, action) => {
        state.preListingMsLoading = false;
        state.preListingMsError = action.payload;
        state.preListingMs = null;
      })
      .addCase(PostEditContact.pending, (state) => {
        state.editedContactLoading = true;
      })
      .addCase(PostEditContact.fulfilled, (state, action) => {
        state.editedContactLoading = false;
        state.editedContact = action.payload;
        state.editedContactError = null;
      })
      .addCase(PostEditContact.rejected, (state, action) => {
        state.editedContactLoading = false;
        state.editedContactError = action.payload;
        state.editedContact = null;
      })
      .addCase(getOrganisationSuburbs.pending, (state) => {
        state.organisationSuburbsLoading = true;
      })
      .addCase(getOrganisationSuburbs.fulfilled, (state, action) => {
        state.organisationSuburbsLoading = false;
        state.organisationSuburbs = action.payload;
        state.organisationSuburbsError = null;
      })
      .addCase(getOrganisationSuburbs.rejected, (state, action) => {
        state.organisationSuburbsLoading = false;
        state.organisationSuburbsError = action.payload;
        state.organisationSuburbs = [];
      });
  },
});

export const selectProspects = (state) => state.prospectSlice.prospects;
export const selectActiveTab = (state) => state.prospectSlice.activeTab;

export const selectFilteredProspects = createSelector(
  [selectProspects, selectActiveTab],
  (prospects, activeTab) => {
    switch (activeTab) {
      case "all":
        return prospects;
      case "continuous":
        return {
          ...prospects,
          data: prospects?.data?.filter(
            (prospect) => prospect?.been_contacted === 0
          ),
        };
      // Add more cases for other tabs
      default:
        return prospects;
    }
  }
);

export const allNotes = (state) => state.prospectSlice.prospectNotes;
export const noteType = (state) => state.prospectSlice.showGeneralNotes;

export const filteredProspectsNote = createSelector(
  [allNotes, noteType],
  (notes, type) => {
    switch (type) {
      case true:
        return notes;
      case false:
        return notes?.filter((note) => note?.type?.id !== 2);

      // Add more cases for other tabs
      default:
        return notes;
    }
  }
);

export const {
  clearProspects,
  setActiveTab,
  setCurrentIndexSlice,
  incrementIndex,
  decrementIndex,
  setGeneralNotes,
  updateIndividualProspect,
} = prospectSlice.actions;

export default prospectSlice.reducer;
